import State from 'store/State';

export const selectStreamState = (state: State) => state.streams;
